var v = Object.defineProperty;
var y = Object.getOwnPropertySymbols;
var Q = Object.prototype.hasOwnProperty, A = Object.prototype.propertyIsEnumerable;
var m = (e, u, n) => u in e ? v(e, u, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[u] = n, s = (e, u) => {
  for (var n in u || (u = {}))
    Q.call(u, n) && m(e, n, u[n]);
  if (y)
    for (var n of y(u))
      A.call(u, n) && m(e, n, u[n]);
  return e;
};
var d = (e, u, n) => new Promise((r, a) => {
  var c = (i) => {
    try {
      o(n.next(i));
    } catch (w) {
      a(w);
    }
  }, t = (i) => {
    try {
      o(n.throw(i));
    } catch (w) {
      a(w);
    }
  }, o = (i) => i.done ? r(i.value) : Promise.resolve(i.value).then(c, t);
  o((n = n.apply(e, u)).next());
});
var _ = /* @__PURE__ */ ((e) => (e.Iframe = "iframe", e.Qiankun = "qiankun", e))(_ || {});
function b({
  Vue: e,
  rootComponent: u,
  appOptions: n
}) {
  let r = null;
  function a(t = {
    container: null
  }) {
    const { container: o } = t;
    r = new e(s({
      render: (i) => i(u)
    }, n)).$mount(
      o ? o.querySelector(n.el) : n.el
    );
  }
  return n.mode === _.Iframe ? (a(), {}) : (window.__POWERED_BY_QIANKUN__ || a(), {
    mount(t) {
      return d(this, null, function* () {
        a(t);
      });
    },
    bootstrap() {
      return d(this, null, function* () {
        typeof n.bootstrap == "function" && (yield n.bootstrap());
      });
    },
    unmount() {
      return d(this, null, function* () {
        r == null || r.$destroy(), r.$el.innerHTML = "", r = null;
      });
    },
    update(t) {
      return d(this, null, function* () {
        typeof n.update == "function" && (yield n.update(t));
      });
    }
  });
}
var l = {};
/*!
 * vite-plugin-qiankun.js v1.0.14
 * (c) 2021-2022 Teng Mao Qing
 * Released under the MIT License.
 */
Object.defineProperty(l, "__esModule", { value: !0 });
var f = typeof window != "undefined" ? window.proxy || window : {}, k = function(e) {
  f != null && f.__POWERED_BY_QIANKUN__ && (window.moudleQiankunAppLifeCycles || (window.moudleQiankunAppLifeCycles = {}), f.qiankunName && (window.moudleQiankunAppLifeCycles[f.qiankunName] = e));
};
l.default = k;
var W = l.qiankunWindow = f, q = l.renderWithQiankun = k;
function E({
  createApp: e,
  rootComponent: u,
  appOptions: n
}) {
  let r = null;
  function a(c = {
    container: null
  }) {
    const { container: t } = c;
    r = e(u), Array.isArray(n.useList) && n.useList.forEach((o) => r.use(o)), r.mount(
      t ? t.querySelector(n.el) : n.el
    );
  }
  if (n.mode === _.Iframe)
    a();
  else {
    let c;
    q({
      mount(t) {
        a(t);
      },
      bootstrap() {
        return d(this, null, function* () {
          typeof n.bootstrap == "function" && (yield n.bootstrap());
        });
      },
      unmount() {
        r == null || r.unmount(), r = null;
      },
      update(t) {
        return d(this, null, function* () {
          typeof n.update == "function" && (yield n.update(t));
        });
      }
    }), W.__POWERED_BY_QIANKUN__ || a();
  }
}
export {
  b as vue2Adaptor,
  E as vue3Adaptor
};
